import {SlctFormat, SlctOption} from 'module/Slct/type/SlctType'
import {cssSlctEllipsis} from 'module/Slct/style/SlctStyle'

function wrapString(x: string) {
	return <div css={cssSlctEllipsis} dangerouslySetInnerHTML={{__html: x}}/>
}

export function getOptionLabel<ModelType extends object | void, ValueType extends string | number>(displayFormat = SlctFormat.ValueLabel, o: SlctOption<ModelType, ValueType> | null | undefined) {
	if (!o) return null
	if (o.jsx) return <div css={cssSlctEllipsis}>{o.jsx}</div>
	if (o.html) return wrapString(o.html)
	let {value, label} = o
	if (!label && label !== 0) label = ''
	if (typeof label === 'number') label = label + ''
	if (typeof label !== 'string') return wrapString(label)
	if (!value && value !== 0) {
		if (label?.trim()) return wrapString(`${label}`)
		return null
	}
	if (!label.trim()) return wrapString(value + '')
	switch (displayFormat) {
		case SlctFormat.ValueLabel:
			return wrapString(`${value}&nbsp;-&nbsp;${label}`)
		case SlctFormat.Value:
			return wrapString(`${value}`)
		default:
		case SlctFormat.Label:
			return wrapString(`${label}`)
		case SlctFormat.LabelValue:
			return wrapString(`${label}&nbsp;(${value})`)
	}
}